export const logoKeys = ["S", "A", "M", "W", "H", "O"] as const;

export type LogoKey = (typeof logoKeys)[number];
